<template>
  <div>
    <AvailableAppointment
      v-if="canShowAvailableAppointment"
      ref="availableAppointmentRef"
      :student="selectedStudent"
      :showCalendar="false"
      :service-type-id="serviceTypeId"
      :is-read-only="isReadOnly || !canEditTab5"
      @select-schedule="selectSchedule"
      @change-section="changeSection"
      @change-municipality="validateNextAppointmentDate"
      @set-show-create-new-referral-option="onSetShowCreateNewReferralOption"
      @getWeekDays="getWeekDays($event)"
    />
    <div v-if="canShowAvailableAppointment" class=" col-md-12 col-sm-12">
      <div>
        <ValidationObserver ref="referralReason">
          <ValidationProvider
            v-slot="{ errors }"
            class="w-100"
            name="razón de referido"
            rules="required"
          >
            <CustomTextArea
              id="referralReason"
              v-model="referralReason"
              class="w-100"
              label=" Indique las necesidades académicas o funcionales que presenta el estudiante y cómo el especialista podría apoyar:"
              :maxlength="3000"
              placeholder="Razón de Referido"
              required
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
            />
          </ValidationProvider>
        </ValidationObserver>
      </div>
    </div>
    <AvailableAppointment
      v-if="canShowAvailableAppointment"
      ref="availableAppointmentServiceCenterRef"
      :student="selectedStudent"
      :service-type-id="12"
      :showCalendar="false"
      :is-read-only="isReadOnly || !canEditTab5"
      @select-schedule="selectSchedule"
      @change-section="changeSection"
      @getWeekDays="getWeekDays($event, evaluationTypes.Centro_Servicio)"
      @set-show-create-new-referral-option="onSetShowCreateNewReferralOption"
    />
    <div v-if="weekDays.length > 0 && canShowAvailableAppointment">
      <div class="col-12 mt-5">
        <section-title
          title="Calendario de Espacios Disponible"
          :has-line="true"
        />
      </div>
      <div class="row mt-4 ml-1">
        <WeekCalendar
          :days="weekDays"
          @select-schedule="selectSchedule"
          @change-week="updateWeekDates"
          @onSelectedDate="updateWeekDates"
        />
      </div>
    </div>
    <ConfirmAppointment
      v-if="canShowConfirmAppointment"
      :student="selectedStudent"
      :client-appointment-id="clientAppointmentId"
      @change-section="changeSection"
      :referralReason="referralReason"
      @confirm-save="() => (referralReason = null)"
    />
    <CoordinatedAppointmentView
      v-if="canShowCoordinatedAppointment"
      :messages="resources"
      :items="coordinatedAppointments"
      :pagination="pagination"
      @pagination-go-page="searchPageNumber"
      @getCoordinations="getCoordinations"
    />
  </div>
</template>

<script>
import AvailableAppointment from '../components/tab5/AvailableAppointment';
import ConfirmAppointment from '../components/tab5/ConfirmAppointment';
import CoordinatedAppointmentView from '../components/tab5/CoordinatedAppointmentView';
import resourcesService from '@/services/resources.js';
import alert from '@/mixin/alert.mixin';
import appointmentServices from '@/services/api/appointment.api';
import store from '@/store/index';
import CustomTextArea from 'CustomTextArea';
import WeekCalendar from '@/components/common/WeekCalendar/WeekCalendar';
import evaluationTypes from '@/utils/constants/student/evaluationTypes';
import evaluations from '@/router/routes/evaluations';
import SectionTitle from 'SectionTitle';

export default {
  mixins: [alert],
  components: {
    AvailableAppointment,
    ConfirmAppointment,
    WeekCalendar,
    CoordinatedAppointmentView,
    CustomTextArea,
    SectionTitle,
  },
  data() {
    return {
      clientAppointmentId: null,
      coordinatedAppointments: [],
      weekDays: [],
      pagination: {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 0,
      },
      referralReason: null,
      pageSize: 10,
      resources: [],
      evaluationTypeId: 1,
      canEditTab5: store.getters.HasPermission('registry.editTab5'),
    };
  },
  props: {
    validations: {
      type: Object,
      default: () => ({
        hasAppointment: false,
        nextAppointment: '',
      }),
    },
  },
  computed: {
    currentSection() {
      return Number(this.$route.query.section) || 1;
    },
    canShowAvailableAppointment() {
      return this.currentSection === 1;
    },
    canShowConfirmAppointment() {
      return this.currentSection === 2 && this.clientAppointmentId > 0;
    },
    canShowCoordinatedAppointment() {
      return (
        this.currentSection === 3 && this.coordinatedAppointments.length > 0
      );
    },
    isReadOnly() {
      let studentStatus = this.$store.getters.SelectedStudent.status;
      return studentStatus !== 'Registro' && studentStatus !== 'Evaluado';
    },
    preRegistry() {
      return this.$store.getters['$_student/getStudentPreRegistry'];
    },
    isPostRegistry() {
      return this.preRegistry?.isPostRegistry;
    },
    selectedStudent() {
      let getter = this.$store.getters;
      let regStudentId = this.preRegistry?.regStudentId;

      return {
        ...getter.SelectedStudent,
        isInitialRegister: this.isPostRegistry,
        regStudentPostRegistryId: this.isPostRegistry ? regStudentId : null,
      };
    },
    serviceTypeId() {
      return !this.isPostRegistry ? 1 : 2;
    },
    evaluationTypes() {
      return evaluationTypes;
    },
    evaluationTypeBasedOnServiceType() {
      return this.isPostRegistry
        ? this.evaluationTypes.Evaluacion_Adicional
        : this.evaluationTypes.Evaluacion_Inicial;
    },
  },
  methods: {
    getWeekDays(data, evaluationTypeId) {
      this.weekDays = data.weekDays;
      if (evaluationTypeId) this.evaluationTypeId = evaluationTypeId;
      else this.evaluationTypeId = data.evaluationTypeId;
    },
    updateWeekDates(data) {
      const appointmentRefs = {
        [this.evaluationTypes.Evaluacion_Inicial]: this.$refs
          .availableAppointmentRef,
        [this.evaluationTypes.Evaluacion_Adicional]: this.$refs
          .availableAppointmentRef,
        [this.evaluationTypes.Centro_Servicio]: this.$refs
          .availableAppointmentServiceCenterRef,
      };

      const availableAppointmentRef = appointmentRefs[this.evaluationTypeId];

      if (
        availableAppointmentRef &&
        availableAppointmentRef.getAvailableDates
      ) {
        const date = data.startDate || data;
        availableAppointmentRef.getAvailableDates(date);
      }
    },
    searchPageNumber(pageNumber) {
      this.pagination.currentPage = pageNumber;
      this.getCoordinations(pageNumber);
    },
    async selectSchedule(schedule) {
      if (!(schedule.scheduleId && schedule.scheduleId > 0)) return;
      var isValidReason = await this.$refs.referralReason.validate();

      if (isValidReason) {
        this.clientAppointmentId = schedule.scheduleId;
        this.onSetShowCreateNewReferralOption(false);
        const nextSection = 2;
        this.changeSection(nextSection, this.evaluationTypeId);
      }
    },
    changeSection(goToSection, evaluationTypeId = null) {
      if (!goToSection) return;

      let goToUrl = `/student/registrygeneral?section=${goToSection}`;
      goToUrl = !evaluationTypeId
        ? goToUrl
        : `${goToUrl}&evaluationTypeId=${evaluationTypeId}`;

      if (goToUrl != this.$route.fullPath) {
        this.$router.replace(goToUrl);
      }
    },
    updatePagination(totalRows) {
      this.pagination.totalItemCount = totalRows;
      this.pagination.count = this.pageSize;
      this.pagination.pageCount = Math.ceil(
        this.pagination.totalItemCount / this.pageSize
      );
    },
    async afterConfirmAppointment() {
      let studentSieid = this.$store.getters.SelectedStudent.studentId;
      const self = this;
      await self
        .$ApiGet('api/student/studentcurrentstatus', {
          studentSieId: studentSieid,
        })
        .then((response) => {
          this.$store.getters.SelectedStudent.status = response.data.statusName;
        });
    },
    async changeInitialEvaluationFlag() {
      try {
        let regstudentpostregistryid = parseInt(
          this.isPostRegistry ? this.preRegistry?.regStudentId : null
        );

        await this.$ApiPost('api/studentregistry/hasactiveevaluations', {
          regStudentPostRegistryId: regstudentpostregistryid,
        });

        let question = '';
        if (this.preRegistry.hasInitialEvaluationFlag == 1) {
          question = this.resources['4683501'];
        } else {
          question = this.resources['4683502'];
        }
        const answer = await alert.methods.ShowCancelModal(
          'Aviso',
          question,
          'Sí',
          'No'
        );
        if (answer) {
          await this.$ApiPost(
            'api/studentregistry/changeinitialevaluationflag',
            { regStudentPostRegistryId: regstudentpostregistryid }
          ).then((response) => {
            this.$store.getters[
              '$_student/getStudentPreRegistry'
            ].hasInitialEvaluationFlag = response.data;
            let tabList = [6];
            if (response.data == 0) {
              tabList.push(5);
            } else {
              this.$emit('set-visibility', [5], false);
            }

            this.$emit('set-visibility', tabList, true);
          });
          this.$emit('select-tab', 6);
          this.ShowToast(
            'Proceso exitoso',
            this.resources['0636'],
            this.toastType.Success
          );
        }
      } catch ({ response: error }) {
        this.ShowToast('Error', error.data.message, this.toastType.Error);
      }
    },
    async loadResources() {
      let resourceCodes = [
        '0636',
        '4683501',
        '4683502',
        '0675',
        'R90020',
        '0019',
        'R90020',
        'R90021',
      ];

      this.resources = await resourcesService.LoadValidationMessages(
        resourceCodes
      );
    },
    async getCoordinations(pageNumber = 1) {
      const { data } = await appointmentServices.getAppointmentRegistryData({
        SieIdOrAppointmentId: this.$store.getters.SelectedStudent.studentId,
        isPostRegistry: this.isPostRegistry,
        pageNumber,
        pageSize: this.pageSize,
      });

      this.coordinatedAppointments = data.data;

      if (this.coordinatedAppointments.length > 0) {
        this.updatePagination(data.totalItemCount);
        this.changeSection(3);
      } else this.changeSection(1);
    },
    async fetchCoordinations() {
      await this.getCoordinations();
      this.$store.commit(
        'setChangeInitEvaluationMethod',
        this.changeInitialEvaluationFlag
      );
      this.$store.commit(
        'setAfterConfirmAppointmentMethod',
        this.afterConfirmAppointment
      );
    },
    async validateNextAppointmentDate() {
      const availableAppointmentRef = this.$refs.availableAppointmentRef;
      if (availableAppointmentRef && availableAppointmentRef.options) {
        const data = availableAppointmentRef.options;
        const { discipline, municipality } = data;
        if (
          discipline &&
          municipality &&
          discipline.id > 0 &&
          municipality.id > 0
        ) {
          const {
            data,
          } = await appointmentServices.validateNextAppointmentDate({
            disciplineId: discipline.id,
            municipalityId: municipality.id,
          });
          this.$emit('updateValidationNextAppointment', data);
        }
      }
    },
    onSetShowCreateNewReferralOption(value) {
      this.$emit('set-show-create-new-referral-option', value);
    },
  },
  watch: {
    async '$route.query.section'(newVal) {
      if (newVal == 3) {
        await this.fetchCoordinations();
        this.weekDays = [];
      }
    },
  },
  async mounted() {
    await this.loadResources();
    await this.fetchCoordinations();
  },
};
</script>
